module.exports = __webpack_public_path__ + "media/paso2019.456955c1.mp4";